import React from 'react';
import { AtSignIcon, MailIcon } from 'lucide-react';
import { ColombiaFlag } from '../ColombiaFlag';
import { contact } from '../../data/landing';
export function Footer() {
  return <footer className="bg-brand px-5 py-14" data-id="element-121" data-mp="2f4ju3xh29v15">
      <div className="mx-auto max-w-3xl text-center" data-id="element-122" data-mp="2f4bie8wocvrj">
        <p className="flex items-center justify-center gap-3 text-xl font-black uppercase tracking-[0.15em] text-white" data-id="element-123" data-mp="2a578th5u8w0o">
          <ColombiaFlag className="h-4 w-6" data-id="element-124" data-mp="1mh7k0ms37foq" />
          Hábil Online™
        </p>
        <p className="mt-4 text-base text-white" data-id="element-125" data-mp="1hhl588wm1rdt">
          El sistema de curación N°1 para personas con colon irritable en Colombia.
        </p>
        <p className="mt-1 text-sm text-white/75" data-id="element-126" data-mp="1w7a94bw389hs">
          Porque cuidar tu digestión no debería costarte tu vida social.
        </p>
        <ul className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm" data-id="element-127" data-mp="13poea86ohnj0">
          <li data-id="element-128" data-mp="13nbs1itw0r05">
            <a href={`mailto:${contact.email}`} className="flex items-center gap-2 text-white transition-colors duration-150 ease-out hover:text-gold" data-id="element-129" data-mp="yqto2l6dswov">
              <MailIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-130" data-mp="1ijntpf86f7zy" />
              {contact.email}
            </a>
          </li>
          <li data-id="element-131" data-mp="1nbfaiy1j5zcw">
            <a href={`https://instagram.com/${contact.instagram.replace('@', '')}`} target="_blank" rel="noreferrer" className="flex items-center gap-2 text-white transition-colors duration-150 ease-out hover:text-gold" data-id="element-132" data-mp="1nbp5l01fmwpg">
              <AtSignIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-133" data-mp="zll00n4oomvt" />
              {contact.instagram}
            </a>
          </li>
        </ul>
        <p className="mt-10 text-xs leading-relaxed text-white/60" data-id="element-134" data-mp="19izhmq2cfhpp">
          © Hábil Online™ 2026 — Todos los derechos reservados. Prohibida la reproducción y
          redistribución sin autorización expresa.
        </p>
        <p className="mt-4 text-base font-bold text-gold" data-id="element-135" data-mp="2kxmogyjq541x">
          “Tu colon sano. Tu vida libre. Empieza hoy.”
        </p>
      </div>
    </footer>;
}